"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleQuill = void 0;
const react_1 = __importDefault(require("react"));
const react_quill_1 = __importStar(require("react-quill"));
require("react-quill/dist/quill.snow.css");
const Link = react_quill_1.Quill.import('formats/link');
Link.sanitize = function (url) {
    if (url.toLowerCase().startsWith('http://'))
        return url;
    if (url.toLowerCase().startsWith('https://'))
        return url;
    if (url.toLowerCase().startsWith('mailto://'))
        return url;
    return 'http://' + url;
};
exports.SimpleQuill = react_1.default.forwardRef((props, ref) => {
    return react_1.default.createElement(react_quill_1.default, Object.assign({}, props, { ref: ref, theme: "snow", bounds: "._quill" }));
});
exports.default = exports.SimpleQuill;
